import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "./store/store";
import { useTranslation } from "react-i18next";
import { DEFAULT_CURRENCY } from "./common/constants";
import { changeCategoryLabel } from "./utils/utilities";
import { setCategory } from "./store/appSlice";

interface LanguageProps {
  children: React.ReactNode;
}

const LanguageSync = ({ children }: LanguageProps) => {
  const { i18n } = useTranslation();
  const { category, userInfo, baseLanguage } = useSelector(
    (state: RootState) => state.app,
  );
  const dispatch = useDispatch();
  const { language, currency } = userInfo || {
    language: baseLanguage,
    currency: DEFAULT_CURRENCY,
  };

  useEffect(() => {
    if (language && i18n.language !== language) {
      i18n.changeLanguage(language);
    }

    if (category)
      dispatch(
        setCategory(changeCategoryLabel(language || baseLanguage, category)),
      );
  }, [language, i18n]);
  return <>{children}</>;
};

export default LanguageSync;
